// const $ = jQuery.noConflict();
'use strict';

const Animations = {
	/**
	* @description Cache dom and strings
	* @type {object}
	*/

	/** @description Initialize */
	init: function() {
		this.animationSetup();
	},
	/** @description */

	animationSetup() {
		const canvas = document.getElementById('js-banner-canvas');

		if (canvas) {
			const context = canvas.getContext('2d');
			let count = 0;

			const currentFrame = index => (
				`../wp-content/themes/fws-sproost/src/assets/animations/hero/PT-0${index.toString().padStart(4, '0')}.jpg`
			);

			const img = new Image();
			img.src = currentFrame(0);

			canvas.width = 1000;
			canvas.height = 700;

			const preloadImages = () => {
				for (let i = 0; i < 33; i++) {
					const img = new Image();
					img.src = currentFrame(i);
				}
			};

			preloadImages();

			setTimeout(function() {
				let bgOk = false;

				img.onload = function() {
					context.drawImage(img, 0, 0);
					bgOk = true;
				};

				const updateImage = index => {
					img.src = currentFrame(index);
					if (bgOk) {
						context.drawImage(img, 0, 0);
					}
				};

				const timer = setInterval(function() {
					count++;
					requestAnimationFrame(() => updateImage(count + 1));

					if (count === 33) {
						count = 33;
						clearInterval(timer);
					}
				}, 80);
			}, 1000);
		}
	}
};

export default Animations;